import { Checkbox } from "antd";
import React from "react";

const CheckBox = (props) => {
  const {
    styleClass,
    handleChange,
    name,
    value,
    options = [],
    label,
    disabled = false,
    errors = {},
    errorMessage,
  } = props;

  const errorMsg = errorMessage ? errorMessage : errors?.[name];
  return (
    <>
      <Checkbox
        disabled={disabled}
        name={name}
        checked={value}
        onChange={(e) => handleChange(e)}
        className={`${styleClass}`}
      >
        {label}
      </Checkbox>
      {errorMsg && <span className="errorMsgField">{errorMsg}</span>}
    </>
  );
};

export default CheckBox;
